import { z } from 'zod';

export const getAnEstimateFormSchema = z.object({
  name: z.string().min(1, { message: 'Full name is required' }),
  email: z
    .string()
    .email({ message: 'Invalid business e-mail address' })
    .refine(email => !/(gmail\.com)$/i.test(email), {
      message: 'Personal email addresses (e.g., Gmail) are not allowed',
    }),
  company: z.string().min(1, { message: 'Company name is required' }),
  phone: z.string().optional(),
  project: z.string().min(10, { message: 'Project description must be at least 10 characters' }),
  service: z.enum(['e-commerce', 'app', 'website', 'other'], {
    required_error: 'You need to select a project type.',
  }),
  marketing: z.boolean().optional(),
  gRecaptchaToken: z.string().optional().nullable(),
});
